import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { posts } from '../../utils/data';
import { titleizer } from '../../utils/text';

//the blog page - overview of every post

//the blog page - overview of every post

//the blog page - overview of every post

export const Blog = ({ history }) => {
    const [curPost, setCurPost] = useState("");
    
    useEffect(() => {
        window.scrollTo(0,0);
        if (curPost !== "") {
            setCurPost("");
        };
    }, []);
    useEffect(() => {
        if (curPost !== "") {
            history.push(`/blog/${curPost}`);
        };
    }, [curPost]);

//list of the blog posts. 
    const blogPosts = Object.keys(posts).map((title, idx) => {
        let post = posts[title];
        return <BlogCard key={title}  post={post} title={title} setCurPost={setCurPost} />
    });

    return (
        <div className="content-parent-bg">
            <header className="top-hero">
                <div className="hero-content">
                    <div className="hero-text">
                        <h1 className="mb-0">BLOG</h1>
                    </div>
                </div>
            </header>
            <div className="content-container">
                <section className="content-section mx-0">
                    <div className="blog-posts">
                        { blogPosts }
                    </div>
                </section>
            </div>
        </div>
    );
};

//formats each of the card. 
const BlogCard = ({ setCurPost, post, title }) => {
    return (
        <div className="blog-card-container col-md-6 col-lg-4 position-relative">
            <div className="blog-card">
                <div className="post-img">
                    <img onClick={(e) => setCurPost(title)} src={post['img']} alt={title}></img>
                </div>
                <div className="post-content">
                    <div className="post-text">
                        <h3 onClick={(e) => setCurPost(title)}>{titleizer(title)}</h3>
                        <p>{post["summary"]}</p>
                    </div>
                    <div className="post-btn">
                        <div onClick={(e) => setCurPost(title)} className="btn-link">READ MORE</div>
                    </div>
                </div>
            </div>
        </div>
    )
};


export default withRouter(Blog);
